export type PartnerRole = "owner" | "manager" | "frontDesk";

export interface PartnerCapabilities {
  role: PartnerRole;
  canViewRevenue: boolean;
  canViewProjections: boolean;
  canViewFees: boolean;
  canManageStaff: boolean;
  canExportMembers: boolean;
}

const OWNER: PartnerCapabilities = {
  role: "owner",
  canViewRevenue: true,
  canViewProjections: true,
  canViewFees: true,
  canManageStaff: true,
  canExportMembers: true,
};

const MANAGER: PartnerCapabilities = {
  role: "manager",
  canViewRevenue: true,
  canViewProjections: true,
  canViewFees: true,
  canManageStaff: false,
  canExportMembers: true,
};

const FRONT_DESK: PartnerCapabilities = {
  role: "frontDesk",
  canViewRevenue: false,
  canViewProjections: false,
  canViewFees: false,
  canManageStaff: false,
  canExportMembers: false,
};

const BY_ROLE: Record<PartnerRole, PartnerCapabilities> = {
  owner: OWNER,
  manager: MANAGER,
  frontDesk: FRONT_DESK,
};

// permissionRole is the future backend sub-role on business_owners; until it
// exists this is undefined and defaults to full owner access.
export const capabilitiesFor = (permissionRole?: string): PartnerCapabilities => {
  const normalized = (permissionRole || "").toLowerCase();
  if (normalized === "frontdesk" || normalized === "front_desk" || normalized === "associate") {
    return FRONT_DESK;
  }
  if (normalized === "manager") return MANAGER;
  return OWNER;
};

export default BY_ROLE;
